/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { Pagination } from '~core/models/core.models';
import {
  CreateCustomerSupplierParams,
  CustomerSupplier,
  ListCustomerSupplierRequestParams,
  UpdateCustomerSupplierParams
} from '~core/models/customer-supplier.model';
import { ApiConstantsService } from '~core/services/api-constants.service';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';

@Injectable()
export class CustomerSupplierService {
  private _apiConstantsService = inject(ApiConstantsService);
  protected _authFacade = inject(AuthFacade);

  readonly apiUrl = this._apiConstantsService.customerSupplierUrl;
  private _httpClient = inject(HttpClient);

  read(customerSupplierId: string): Observable<CustomerSupplier> {
    return this._httpClient.get<CustomerSupplier>(
      `${this.apiUrl}/${customerSupplierId}`
    );
  }

  list(
    params?: ListCustomerSupplierRequestParams & { [key: string]: any }
  ): Observable<Pagination<CustomerSupplier>> {
    const billingType = params?.type;
    const httpParams: Record<string, any> = {
      ...params,
      sort: params?.sort || 'createdAt',
      desc: params?.desc || 'createdAt'
    };
    // if (billingType === BillingType.bToB) {
    //   httpParams.nif = `neq(${this._authFacade.currentUser?.organization.nif})`;
    // }
    return this._httpClient.get<Pagination<CustomerSupplier>>(this.apiUrl, {
      params: httpParams
    });
  }

  create(data: CreateCustomerSupplierParams): Observable<CustomerSupplier> {
    return this._httpClient.post<CustomerSupplier>(this.apiUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(
    id: string,
    data: Partial<UpdateCustomerSupplierParams>
  ): Observable<CustomerSupplier> {
    return this._httpClient.patch<CustomerSupplier>(`${this.apiUrl}/${id}`, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  delete(customerSupplierId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${this.apiUrl}/${customerSupplierId}`
    );
  }
}
